import { withTranslation } from 'next-i18next';
import Core from '@core_modules/checkout/components/midtransCoreAPI/core';
import Content from '@core_modules/checkout/components/midtransCoreAPI/components';

const MidtransCoreApi = (props) => (
    <Core
        {...props}
        Content={Content}
    />
);

MidtransCoreApi.getInitialProps = async () => ({
    namespacesRequired: ['common'],
});

export default (withTranslation()(MidtransCoreApi));
